import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';

const config = {
    apiKey: process.env.REACT_APP_FIREBASE_API,
    authDomain: "elucd-dashboard.firebaseapp.com",
    databaseURL: "https://elucd-dashboard.firebaseio.com",
    projectId: "elucd-dashboard",
    storageBucket: "elucd-dashboard.appspot.com",
}

if(!firebase.apps.length){
    firebase.initializeApp(config);
}

const auth = firebase.auth();
const db = firebase.firestore();

if (process.env.NODE_ENV === 'development') {
    console.log('Running Firestore database local emulator');
    db.useEmulator("localhost", 8080);
}

export { db };

export default auth;